import React from "react";

const YearOptions = ({maxSupportedYear = new Date().getFullYear()}) => {
  const years = [];

  for (let year = maxSupportedYear; year >= 1950; year--) {
    years.push(year);
  }

  return (
    <>
      <option value='select'>Select year</option>
      {years?.map((year, index) => (
        <option value={`${year}`} key={`year-${index}`}>
          {year}
        </option>
      ))}
    </>
  );
};

export default YearOptions;
